import { combineReducers } from 'redux';

import { Reducer } from '../../../../types';
import { ScriptEditorAction, StateDocumentPages } from '../../types';
import { transformDocumentPage } from './utils';

import {
  getArticleDocumentPagesSuccess,
  getArticleDocumentPagesFail,
  getArticleDocumentPagesRequest,
  setOpenDocumentPageInstructionModal,
} from '../../actions';

type ReducerOf<T extends keyof StateDocumentPages> = Reducer<StateDocumentPages, ScriptEditorAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getArticleDocumentPagesRequest.type:
      return null;

    case getArticleDocumentPagesSuccess.type:
      return transformDocumentPage(action.payload);

    case setOpenDocumentPageInstructionModal.type:
      return action.payload ? state : null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getArticleDocumentPagesRequest.type:
      return true;

    case getArticleDocumentPagesSuccess.type:
    case getArticleDocumentPagesFail.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateDocumentPages>({
  data,
  loading,
});
